<script>
		import {user, view, change_attribute, fetch_data, send_data, send_images, game} from "../client.svelte.js";
		import {fieldResolution, tokenResolution, filepath_URL, noPersona, Location, calc_defaultCS, isEmpty} from "../core.js";
	  import {SvelteSet} from "svelte/reactivity";
		import Input from "../elements/Input.svelte";
		import Select from "../elements/Select.svelte";
		import Encounter, {mapElement} from "../play/Encounter.svelte";
		import CharCard from "../elements/CharCard.svelte";
		import Catalog from "../elements/Catalog.svelte";
		import CharShort from "./CharShort.svelte";
		import Sidebar from "../elements/Sidebar.svelte";
		import Dialog from "../elements/Dialog.svelte";

		let catalogDialog, variantDialog

		let rescaling = $state(false)
		let newScale = $state(view.map.scale)
		let layers = $derived(Object.values(view.site.layers).map(layID => user.layers.get(layID)))
		let thisLayer = $derived(Object.assign({}, view.map, {ID: `${view.map.SITE}_${view.map.LAYER}`}))

		let deployments = $derived(
			Object.values(Object.fromEntries(
				user.deployments.values()
					.filter(deploy => deploy.ADVT === view.adventure.ID && deploy.SECT === view.section.SECT && deploy.map === view.map.LAYER)
					.map(deploy => {
						const appearChar = (deploy.charID === 'HEROES') ? {affiliation: 'fellow', level: null} : user.characters.get(deploy.charID)
						const callsign = deploy.ID.split("~")[1]
						const appearPers = Object.assign({}, noPersona, {
							ID: callsign, callsign: callsign, deployID: deploy.ID, charID: deploy.charID,
							position: new Location(deploy), orientation: null, level: appearChar.level + 2 * ((deploy.rank ?? 1) - 1),
							rank: deploy.rank, condition: deploy.condition, affil: deploy.affil ?? appearChar.affiliation, })
						return [deploy.ID, appearPers] })
					.toArray() ) )
			.toSorted((a,b) => a.ID.localeCompare(b.ID))  )
		// $inspect(`DEPLOY - deployments`, deployments)


		let characters = new SvelteSet(
			deployments.map(deploy => user.characters.get(deploy.charID)).filter(Boolean))
		let usedCharCSs = $derived(characters.map(char => char.CS))
		// $inspect(`DEPLOY - characters`, characters)

		const catLabels = {'part': "vorbereitete NSCs",  'priv': "persönlicher Katalog", 'publ': "öffentlicher Katalog",
											 'hero': "spielbare Helden", 'heroes': "Eigene Helden"}
		const catSorting = {heroes: 1, hero: 2, part: 3, priv: 4, publ: 5}

		const chars = user.characters.values()
			.filter((char) => char.ZUB !== 'Hero')
			.toArray()
			.sort((char1,char2) => char1.name.localeCompare(char2.name))
		// console.log(chars)

		let filterRace = $state('')
		let filterSubgroup = $state('')
		let filterVocation = $state('')

		const raceOptions = ['', ...new Set(chars.map(char => char.race).filter(Boolean))].sort()
		const subgroupOptions = ['', ...new Set(chars.map(char => char.subgroup).filter(Boolean))].sort()
		const vocationOptions = ['', ...new Set(chars.map(char => char.vocation).filter(Boolean))].sort()

		let filteredChars = $derived(chars.filter(char =>
			(!filterRace || char.race === filterRace) &&
			(!filterSubgroup || char.subgroup === filterSubgroup) &&
			(!filterVocation || char.vocation === filterVocation) ))

		let grpdEntries = $derived(Object.fromEntries(
			Object.entries(
				Object.groupBy(filteredChars, (char) => (char.rubric === view.adventure?.ID) ? 'part' : char.cat))
					.sort(([cat1, list1], [cat2, list2]) => catSorting[cat1] - catSorting[cat2])
					.map(([cat, list]) => [catLabels[cat] ?? cat, list]) ) )

		let variants = $derived(user.characters.values().filter(char => char.ZUB === 'Variant' && char.ADVT === view.adventure.ID).toArray())

		const variantActions = {
			cancel: {id: 'cancel', label: "Abbrechen", symbol: 'cancel', func: close_variantDialog},
			create: {id: 'create', label: "Variante erstellen", symbol: 'plus', func: create_variant},
			edit:   {id: 'edit',   label: "Variante ändern", symbol: 'edit', func: change_variant},
			delete: {id: 'delete', label: "Variante löschen", symbol: 'delete', func: delete_variant},
			newChar: {id: 'newChar', label: "Antagonisten erstellen", symbol: 'char-new', func: create_antagonist}}


		//--- Variant mangement ---//

		function open_catalog() {
				catalogDialog.showModal()
		}

		function select_character(e) {
				catalogDialog.close()
				if (!this.ranks) {		// individuum: use template directly
						characters.add(this)
				} else {						// specimen: only added once a variant is created
						variantActions.create.shown = true
						edit_character.bind(this)(e)
				}
		}

		function edit_character(e) {
				view.character = this
				document.getElementById('variant-dialog').showModal()
		}

		async function create_variant({tknfile = null, ...data}) {
				console.log(`DEPLOY: Create new variant ${data.name} based on ${view.character.ID}`, data)
				const response = await send_data(`/variant/_`, data, 'POST', tknfile)
				document.getElementById('variant-dialog').close()
				variantActions.create.shown = false
				// add new variant to list and set view.character
				view.character = response.characters[0]  // .find(char => char.ZUB === 'Variant' && char.CS === data.callsign)
				if (view.character)
					characters.add(view.character)
		}

		async function create_antagonist() {

		}

		async function change_variant({variID, tknfile = null, ...data}) {
				console.log(`DEPLOY: Change variant ${variID}`, data)
				await send_data(`/variant/${variID}`, data, 'PATCH', tknfile)
				document.getElementById('variant-dialog').close()
				view.character = null
		}

		async function delete_variant(variantID) {
				console.log(`DEPLOY: Delete variant ${variantID}`)
				await send_data(`/variant/${variantID}`, 'DELETE')
				document.getElementById('variant-dialog').close()
				view.character = null
		}

		//--- Deployment ---//

		async function deploy_variant(position, e) {
        console.log(`DEPLOY - deploy new ${this.isIndividuum ? "persona" : "specimen"} of ${this.ID} at ${position}:`, $state.snapshot(this))
        // ToDo: add params (e.g. conditions) either from charCard or from dialog
        const sectSECT = view.section?.SECT ?? user.sections.get(game.section)?.SECT
				if (Object.keys(this.ranks ?? {}).length > 1) {
						const deployData = {action: 'DEPLOY', sectID: sectSECT, callsign: this.CS, charID: this.ID, position: position, map: view.map.ID}
						const options = {'Platzieren':
								Object.keys(this.ranks).map((rank, i) => Object.assign({label: rank, rank: i + 1}, deployData)) }
						view.show_dialog('options', {coord: position.to_coord(), options: options})
						// view.show_dialog('options', {coord: {x: e.clientX, y: e.clientY}, options: options})
				} else {		// deploy individuum directly or default rank
						send_data(`/deploy/_`, {sectID: sectSECT, callsign: this.CS ?? calc_defaultCS(this.name ?? ""), charID: this.ID, position: position, map: view.map.ID,
																		rank: (this.isIndividuum) ? null : 1 })
				}
		}


		//--- Map sizing ---//

		function reset_zoom({target: {value}}) {
			  const newval = (value === "") ? null : (isNaN(value)) ? value : +value
				if (newval)
						newScale = value
		    rescaling = true
		    mapElement.scaleTo(view.map.scale / newScale)
		    mapElement.focus()
		}

		function recalc_scale(e) {
				if (rescaling)
						newScale = Math.round(view.map.scale / getComputedStyle(mapElement).getPropertyValue('--scale'))
		}

		function resize_map() {
				if (rescaling) {
						const layer = user.layers.get(view.site.layers[view.map.LAYER])
						const mapImg = document.getElementById('mapImg')
						const maxSize = Math.max(mapImg.naturalWidth, mapImg.naturalHeight)
						const data = {scale: newScale, factor: Math.round(2 * maxSize / newScale) / 100}
						send_data(`/layer/${layer.ID}`, data, 'PATCH')
			      rescaling = false
		    } else {
						rescaling = true
			      reset_zoom({target: {value: view.map.scale}})     // switches in rescaling mode and focusses map
		    }
		}

		function select_layer(e) {
			  const virtualMap = Object.assign({}, this, {ID: this.LAYER, entities: [], obstacles: [], affects: []})
				view.switch_map(virtualMap)
		}


		function close_variantDialog(e) {
				view.character = null
		}

		async function test_map(e) {
				await fetch_data('test', {advt: view.adventure.ID, scene: view.section.SECT})
				location.reload()
		}


</script>


<!------------------------------- HTML ------------------------------------->

{#snippet npcs()}
	<h4>Beteiligte plazieren</h4>
	<p class="card-meta">Ziehe die Vorlagen auf die Karte, um NSCs aufzustellen. Ein Klick öffnet die Variante.</p>
	{#each characters as character}
		<CharCard data={character} mode='deploy' onselect={edit_character.bind(character)}
		          onaction={{deploy: deploy_variant.bind(character)}}/>
	{/each}
	<button class="button-secondary" onclick={open_catalog}><i class="fa icon-user-plus"></i>Vorlage wählen</button>
{/snippet}

<section id={view.layout.page}>
	<Sidebar flyout={npcs} open='npcs' width={320} items={[
		{id: 'npcs', icon: 'users', label: "NSCs", flyout: "NSCs der Szene"},
		{id: 'catalog', help: 'catalogdialog', icon: 'user-plus', label: "Vorlage wählen", onclick: open_catalog},
		{id: 'test', icon: 'clipboard-user', label: "Karte testen", onclick: test_map} ]}/>

	<article class="mapPane" onwheel={recalc_scale}>
		<fieldset class="floating scaleBox">
			<div class="datatable">
				<Input field=scale value={newScale} type=number separate onchange={reset_zoom} />
				<p>Pixel/Feld</p>
				<div>
					<button class="textBtn" onclick={resize_map}>{(rescaling) ? "setzen" : "anpassen"}</button>
				</div>
				<Input field=visib value={view.map.visib} type=number separate onchange={change_attribute.bind(thisLayer)}/>
				<p class=doublespan>Felder Sichtweite</p>
			</div>
		</fieldset>

		{#if layers.length > 1}
			<nav class="floating layerBox">
				{#each layers as layer}
					<!-- svelte-ignore a11y_click_events_have_key_events, a11y_no_noninteractive_element_interactions -->
					<img src={filepath_URL(layer.filepath)} alt={layer.ID} title={layer.name ?? layer.ID} onclick={select_layer.bind(layer)}>
				{/each}
			</nav>
		{/if}

		<Encounter />

		{#if rescaling}
			<img class=dummyToken style:width="{tokenResolution}px" style:--visrange={view.map.visib}
			     src="assets/tokens/default.png" alt="dummy" style="--resolution: {fieldResolution}px"/>
		{/if}
	</article>

	<dialog bind:this={catalogDialog} class="dlg catalogDialog" data-help="catalogdialog" onclick={() => catalogDialog.close()}>
		<div class="dlg-head">
			<h3>Vorlage wählen</h3>
			<button class="dlg-close" title="Schließen" aria-label="Schließen" onclick={() => catalogDialog.close()}></button>
		</div>
		<div class="dlg-body">
			<div class="filterBar">
				<Select field=race bind:value={filterRace} options={raceOptions} separate/>
				<Select field=subgroup bind:value={filterSubgroup} options={subgroupOptions} separate/>
				<Select field=vocation bind:value={filterVocation} options={vocationOptions} separate/>
			</div>
			<Catalog Card={CharCard} {grpdEntries} onselect={select_character}/>
		</div>
	</dialog>

	<Dialog id='variant-dialog'
					title={(view.character?.ZUB === 'Variant') ? "Variante bearbeiten" : "Variante erstellen"}
					actions={Object.values(variantActions)}>
		{#if view.character}
			<CharShort character={view.character} mode={(view.character?.ZUB === 'Variant') ? 'edit' : 'create'}/>
		{/if}

	</Dialog>
</section>


<!------------------------------- STYLE ------------------------------------->

<style lang="sass">
	@use "../colors" as colors

	h4
		margin: 6px 0 0
		font-size: 13px
		font-weight: 500

	.deployList
		display: grid
		grid-template-columns: 4ch 1fr 3ch 1fr 2fr
		gap: 8px
		font-size: 12px

	.mapPane
		overflow: hidden
		background: radial-gradient(ellipse at 30% 20%, colors.$grey-20, colors.$black 70%)

	.floating
		position: absolute
		z-index: 10
		padding: 4px
		border-radius: 8px
		background: colors.$grey-15
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.6)

	.scaleBox
		top: 12px
		right: 12px
		width: 280px
		margin: 0
		border: 0

	.layerBox
		top: 12px
		right: 12px
		display: flex
		gap: 6px

		img
			max-width: 120px
			max-height: 96px
			border-radius: 4px
			cursor: pointer

	.datatable
		margin: 4px 8px
		display: grid
		grid-template-columns: 5ch 4ch 11ch 12ch
		column-gap: 8px
		align-items: center
		font-size: 13px

		p
			margin: 3px
			padding: 0

	.dummyToken
		position: absolute
		left: calc(100% / 2)
		top: calc(100% / 2)
		--visrange: 100	/* no restriction */

	.dummyToken:after
		content: ''
		position: absolute
		left: calc(-1 * var(--visrange) * 74px + 30px)
		top:  calc(-1 * var(--visrange) * 74px + 30px)
		width: calc(2 * var(--visrange) * 74px)
		height: calc(2 * var(--visrange) * 74px)
		border-radius: 100%
		box-shadow: 0 0 0 8000px rgb(0 0 0 / 50%)
		pointer-events: none

	.catalogDialog
		width: min(1200px, 90vw)

	.filterBar
		display: grid
		grid-auto-flow: column
		grid-template-columns: repeat(3, 1fr)
		grid-template-rows: repeat(2, auto)
		gap: 4px 12px
		margin-bottom: 12px

</style>
